import {
  WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "./renderConfig";
import { buildCsv } from "./agentServiceTimeExport";

const SUMMARY_HEADERS = Object.freeze([
  "Scope",
  "Total Tickets",
  "Total Waiting Time",
  "Avg / Ticket",
  "Avg / Day",
  "Min",
  "Max",
]);
const BREAKDOWN_HEADERS = Object.freeze(["Scope", "Period", "Total Waiting Time", "Average"]);

const toPrimitiveNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getPointPeriod = (point) => point.date ?? point.day ?? point.name ?? point.hour ?? "";

export const getWaitingTimeSummaryRows = (scopes = [], renderConfig) => {
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS,
  });
  return sortReportRows(scopes, config, {
    columnDefinitions: WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS,
  });
};

export const getWaitingTimeSummaryCsvRows = (scopes = [], renderConfig) =>
  getWaitingTimeSummaryRows(scopes, renderConfig).map((row) => [
    row.scopeName || "",
    toPrimitiveNumber(row.totalTickets ?? row.total),
    toPrimitiveNumber(row.totalWaitingTime),
    toPrimitiveNumber(row.avgWaitingTimePerTicket ?? row.average),
    toPrimitiveNumber(row.avgWaitingTimePerDay ?? row.avgWaitingTimePerHour ?? row.averagePerDay),
    toPrimitiveNumber(row.minWaitingTimePerDay ?? row.minWaitingTimePerHour ?? row.min),
    toPrimitiveNumber(row.maxWaitingTimePerDay ?? row.maxWaitingTimePerHour ?? row.max),
  ]);

export const getWaitingTimeBreakdownCsvRows = (scopes = [], renderConfig) =>
  getWaitingTimeSummaryRows(scopes, renderConfig).flatMap((row) =>
    (row.chart || []).map((point) => [
      row.scopeName || "",
      getPointPeriod(point),
      toPrimitiveNumber(point.totalWaitingTime ?? point.total),
      toPrimitiveNumber(point.average ?? point.avg),
    ])
  );

const triggerCsvDownload = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadWaitingTimeSummaryCsvFiles = ({ scopes, renderConfig, filenamePrefix }) => {
  triggerCsvDownload(
    `${filenamePrefix}_summary.csv`,
    buildCsv(SUMMARY_HEADERS, getWaitingTimeSummaryCsvRows(scopes, renderConfig))
  );
  triggerCsvDownload(
    `${filenamePrefix}_breakdown.csv`,
    buildCsv(BREAKDOWN_HEADERS, getWaitingTimeBreakdownCsvRows(scopes, renderConfig))
  );
};
